import { setSourceParams, initUtmSource, getSourceParams } from './source_params.js';



jQuery(document).ready(function () {
    
  setSourceParams();
  initUtmSource();
  getSourceParams();




  setTimeout(function(){
    if(jQuery('.carusel-landing-page .reusable-form-section .bottom main .bottom2 .form-holder form ul.list-group.form-contact-us.details li.list-group-item input[name="contact_email"]').data('required') == 1){
        jQuery(' #contact_email').parents('.list-group-item').children('label').html('*'+jQuery(' #contact_email').parents('.list-group-item').children('label').html());
    }
  });


  console.log("ready");
  if (jQuery('#landingmobilepopup').length > 0) {
    jQuery('.wpcf7-form-control-wrap .wpcf7-form-control').focus(function () {
      jQuery(this).parents('li').find("label").addClass('focus');
    })
    jQuery('.wpcf7-form-control-wrap .wpcf7-form-control').blur(function () {
      if (!jQuery(this).val()) {
        jQuery(this).parents('li').find("label").removeClass('focus');
      }
    })
    jQuery('.wpcf7-form-control-wrap select.wpcf7-form-control').change(function () {
      if (!jQuery(this).val()) {
        jQuery(this).parents('li').find("label").removeClass('focus');
      }
      else {
        jQuery(this).parents('li').find("label").addClass('focus');
      }
    })
  }




  setScreenHeight();
  hideModelField();
  initCarusel();
  navSliderInit();
  openPollutionSafety();
  stopVideo();
  document.querySelector("body").onresize = function () {
    //setScreenHeight();
    //  if (jQuery(".slider-nav ul").hasClass("slick-initialized")) {
    //   // Remove the Slick slider on resize
    //   jQuery(".slider-nav ul").slick("unslick");
    // }
    //  navSliderInit();
  };
  //add class to site-content (set height on mobile)
  if (jQuery(".wrap-slider").hasClass("has-safety")) { jQuery(".site-content").addClass("has-safety"); }
  //open form on mobile
  if (jQuery(".openform").length) {
    jQuery(".openform").on("click", function () {
      console.log("click! ", jQuery("#landingmobilepopup .close"));
      if (!jQuery("#landingmobilepopup .close.close-form").length) {
        jQuery("#landingmobilepopup .modal-dialog").append('<button type="button" class="close close-form" data-dismiss="modal"></button>');
        jQuery("#landingmobilepopup .close").on("click", function () {
          jQuery("#landingmobilepopup").hide();
          jQuery("#landingmobilepopup").removeClass("show");

        });
      }
      jQuery("#landingmobilepopup").show();
      jQuery("#landingmobilepopup").addClass("show");

    })

  }


  jQuery('.brands').on('change', function () {
    if (jQuery('.brands option:selected').val() != '') {
      jQuery('.models').attr('disabled', false);
      jQuery('.models option:selected').attr('selected', false);
      jQuery('input[name="manufacture"]').val(jQuery('.brands option:selected').val().toUpperCase());

      var url = '/wp-admin/admin-ajax.php';
      jQuery.ajax({
        url: url,
        type: 'POST',
        data: {
          action: 'lu_carrousel_get_showroom_by_brand',
          brand: jQuery('.brands option:selected').val().toUpperCase()
        },

        success: function (res) {
          //console.log(res)
          //res = JSON.parse(res);
          if (res) {
            jQuery('.contact_showroom').html(res);
            jQuery('.contact_showroom').attr('disabled', false);
            jQuery('.contact_showroom').parents('.list-group-item').find('label').addClass('focus');
          } else {
            jQuery('.contact_showroom').html('');
            jQuery('.contact_showroom').parents('.list-group-item').find('label').removeClass('focus');
          }
        }
      });
    }
    jQuery('.models select.models').empty();
    jQuery('.wpcf7-form-control-wrap.models').parent().children('label').addClass('focus');
    jQuery('.models select.models_hidden option').each(function () {
   
      if (jQuery(this).data('brand').toUpperCase() == jQuery('.brands option:selected').val().toUpperCase()) {
        jQuery('.models select.models').append('<option data-brand="'+jQuery(this).data('brand')+'" value="'+jQuery(this).val()+'">'+jQuery(this).text()+'</option>');
      } else {

        // jQuery(this).hide();
        // jQuery(this).wrap('<span>');
      };

    });

  });


  jQuery('.read_more_text, .read_less_text').on('click', function (e) {
    e.preventDefault();
    // jQuery(this).toggle();
    jQuery(this).parent('span').children('.show_more').toggle();
    jQuery(this).parent('span').children('.read_more_text').toggle();
    jQuery(this).parent('span').children('.read_less_text').toggle();

  });

  jQuery('.carusel-landing-page .reusable-form-section .bottom main .bottom2 .form-holder form ul.list-group.form-contact-us.details li.list-group-item.submit-btn .details_btn').on('click', function (e) {
    e.preventDefault();
    var jQuerythis = this;
    jQuery(this).attr('disabled', 'disabled');
    jQuery('div.wpcf7lu .wpcf7-spinner').css({ 'display': 'inline-block' });
    jQuery('div.wpcf7lu .wpcf7-spinner').css({ 'visibility': 'visible' });
    if (luCarousselValidForm(jQuery('.carusel-landing-page .reusable-form-section form'))) {
      jQuery('.empty_fields_error').hide();
      var formData = jQuery('.carusel-landing-page .reusable-form-section form').serializeArray();
      var url = '/wp-admin/admin-ajax.php';
      let searchParams = new URLSearchParams(window.location.search)
      var camp = '';
      if (searchParams.has('rcamp')) {
        camp = searchParams.get('rcamp')
      }
      else if (searchParams.has('campaign')) {
        camp = searchParams.get('campaign')
      }
      if (!camp)
        camp = jQuery('.form_campaign_code').text();

      jQuery.ajax({
        url: url,
        type: 'POST',
        data: {
          action: 'lu_carousel_createlead',

          model: jQuery('#models').val(),
          full_name: jQuery('#full_name').val(),
          contact_phone: jQuery('#contact_phone').val(),
          contact_email: jQuery('#contact_email').val(),
          companycode: (jQuery('#brands').val().toUpperCase() == 'MG') ? 6 : 1,
          manufacture: jQuery('#brands').val().toUpperCase(),
          form_campaign_code: camp,
          form_default_showroom: jQuery('#contact_showroom').val(),
          spam_question: jQuery('.spam-question input:checked').val(),
          privacyQuestion: jQuery('.privacy-question input:checked').val(),
          utmSource: jQuery('input[name="utmSource"]').val(),
          gclid: jQuery('input[name="gclid"]').val(),
          utmMedium: jQuery('input[name="utmMedium"]').val(),
          utmCampaign: jQuery('input[name="utmCampaign"]').val(),
          utmContent: jQuery('input[name="utmContent"]').val(),
          utmTerm: jQuery('input[name="utmTerm"]').val(),
          rcamp: jQuery('input[name="rcamp"]').val(),
          ref: jQuery('input[name="ref"]').val(),
          adid: jQuery('input[name="adid"]').val(),
          adsetid: jQuery('input[name="adsetid"]').val(),
          clickid: jQuery('input[name="clickid"]').val(),
          sitesourcename: jQuery('input[name="sitesourcename"]').val(),
          placement: jQuery('input[name="placement"]').val(),
          spamtext: (jQuery('.spam-question input:checked').val())?jQuery('input[name="spamtext"]').val():'',

          // apiurl: jQuery('.codeoasis_api_link').html()
        },

        success: function (res) {
          res = JSON.parse(res);

          if (res.errorcode == '200' || res.errorcode == '201') {
            jQuery("form .list-group").hide();
            jQuery(".form-holder .title-subtitle").hide();
            jQuery("#thankyou button.close").hide();
            jQuery('#thankyoulp').show();
          }
          else {

          }

          setTimeout(function () {
            jQuery('div.wpcf7lu .wpcf7-spinner').hide();
            jQuery('div.wpcf7lu .wpcf7-spinner').css({ 'visibility': 'hidden' });
            jQuery(jQuerythis).attr('disabled', false);
          }, 1000);

        }
      });
    }
    else {
      setTimeout(function () {
        jQuery('div.wpcf7lu .wpcf7-spinner').hide();
        jQuery(jQuerythis).attr('disabled', false);
      }, 1000);
    }
  });

});
function hideModelField() {
  var interval = setInterval(function () {
    var element = document.querySelector('.page-template-template-carusel_landing_page');

    if (element) {

      if (jQuery('.page-template-template-carusel_landing_page input[name="is_email_required"]').val() == 'Yes') {
        jQuery('.page-template-template-carusel_landing_page #contact_email').parents('.list-group-item').find('.text-danger').html('*');
      }

      if (jQuery('.page-template-template-carusel_landing_page input[name="show_models"]').val() == 'No' || jQuery('.page-template-template-ds_experience #models option').length == 1) {
        jQuery('.page-template-template-carusel_landing_page #models').parents('.list-group-item').hide();
      }
      clearInterval(interval);
    }
  }, 1000);



}
function initCarusel() {

  var slider = jQuery('.nav-button'),
    wrapper = jQuery('#wrapper-slider'),
    animating = false,
    current = 0,
    lengthDiv = slider.length,
    delay = 1000;
  slider.on('click', function (e) {
    var anchor = jQuery(this).closest(".nav-button");
    if (!animating) {
      animating = true;
      jQuery('.nav-button').removeClass('active');
      anchor.addClass("active");
      console.log("anchor ", anchor);
      // jQuery('nav').scrollLeft(anchor.outerWidth()/2+document.querySelector("#nav_5").offsetLeft); 
      if (window.screen.width < 768) {
        anchor[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
      }
      let className = anchor[0].className;
      let regex = /nav_([\d]+)/;
      let match = className.match(regex);
      console.log(match[0]);
      jQuery("." + match[0]).addClass("active");
      let currunt = 0
      if (match) {
        current = parseInt(match[1]);
      }


      let slide = document.querySelector("#wrapper-slider > div:nth-child(" + (current * 1 + 1) + ")");
      if (slide) {
        if (slide.querySelector(".pollution-safety-bar"))
          jQuery(".slider-nav").addClass("has-safety");
        else
          jQuery(".slider-nav").removeClass("has-safety");
      }

      let fullWidthClass = wrapper.hasClass('full-width') ? 'full-width' : '';
      wrapper.removeClass().addClass(fullWidthClass + ' slide' + current);
      let translate = "translateX(" + current * 100 + "%)";
      wrapper.css({ "-webkit-transform": translate });
      setTimeout(function () {
        animating = false;
      }, delay);
      if (jQuery('.panel-bottom.active').length) { jQuery('.panel-bottom.active').removeClass('active') }
      e.preventDefault();
    }
  });
}
function navSliderInit() {
  var rs = getComputedStyle(document.querySelector(':root'));
  let height = parseInt(rs.getPropertyValue('--screenHeight'), 10);
  let slideCount = 6;
  if (height < 950) {
    slideCount = 5;
  }
  if (height < 700) {
    slideCount = 4;
  }
  if (height < 600) {
    slideCount = 3;
  }
  let verticalSlider = jQuery(".slider-nav ul");
  verticalSlider.slick({

    // mobileFirst: true,
    slidesToShow: slideCount,
    centerMode: true,
    centerPadding: '50px',
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    rtl: false, draggable: false, dots: false, infinite: true, focusOnSelect: true, slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"

        // settings: {
        //   slidesToShow: 3,

        //   arrows: false,

        //   rtl: true,

        //   centerMode: true,





        // }
      }]
  }



  )

  //select first item
  if (document.querySelector(".nav_0")) {
    document.querySelector(".nav_0").click();
  }

  /**
  * FIX JUMPING ANIMATION
  * Set special animation class on first or last clone.
  * https://github.com/kenwheeler/slick/issues/3419
  */
  if (window.screen.width > 768) {
    verticalSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      var
        direction,
        slideCountZeroBased = slick.slideCount - 1;

      if (nextSlide == currentSlide) {
        direction = "same";

      } else if (Math.abs(nextSlide - currentSlide) == 1) { // 1 or -1
        if (slideCountZeroBased === 1) { // If there's only two slides
          direction = "duo";
        } else { // More than two slides
          direction = (nextSlide - currentSlide > 0) ? "right" : "left";
        }
      } else { // e.g., slide 0 to slide 6
        direction = (nextSlide - currentSlide > 0) ? "left" : "right";
      }

      // Add a temp CSS class for the slide animation (.slick-current-clone-animate)

      if (direction == 'right') {
        jQuery('.slick-cloned[data-slick-index="' + (nextSlide + slideCountZeroBased + 1) + '"]', verticalSlider).addClass('slick-current-clone-animate');
      }

      if (direction == 'left') {
        jQuery('.slick-cloned[data-slick-index="' + (nextSlide - slideCountZeroBased - 1) + '"]', verticalSlider).addClass('slick-current-clone-animate');
      }
    });

    verticalSlider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
      jQuery('.slick-current-clone-animate', verticalSlider).removeClass('slick-current-clone-animate');
      jQuery('.slick-current-clone-animate', verticalSlider).removeClass('slick-current-clone-animate');
    });
  }
}
function setScreenHeight() {
  //set height
  let header = 0;
  let footer = 0;
  if (jQuery('header').length) {
    header = jQuery('header')[0].offsetHeight;
  }
  else if(jQuery('.headr_o')){
    header = jQuery('.headr_o')[0].offsetHeight;

  }
  if (jQuery('footer').length) { footer = jQuery('footer')[0].offsetHeight; }
  let height = window.innerHeight;//- header;// - footer
  var r = document.querySelector(':root');
  r.style.setProperty('--screenHeight', height + "px");
  r.style.setProperty('--screenTop', header + "px");
  let widthScreen = window.innerWidth;
  r.style.setProperty('--navWidth', widthScreen / 3.5 + "px");
  r.style.setProperty('--navBorderWidth', widthScreen / 3.5 - 5 + "px");
  r.style.setProperty('--navButtonWidth', widthScreen / 3.5 - 17 + "px");
  let navGap = (widthScreen - (107 * 3.5)) / 3;
  r.style.setProperty('--navGap', navGap + "px");
  r.style.setProperty('--navButtonCount', jQuery(".nav-button").length);
  console.log('navButtonCount ', jQuery(".nav-button").length, 'navBorderWidth ', widthScreen / 3.5 - 5, 'navButtonWidth ', widthScreen / 3.5 - 17);

}
function openPollutionSafety() {
  jQuery('.panel-top').on('click', function () {
    let table = jQuery('.panel-popup');
    table.toggleClass('active');//slideToggle();
    table.find(".close-wrapper").on('click', function () {
      table.removeClass('active');
    })

  });

}
function stopVideo() {
  jQuery(".play").click(function () {
    let mainVideo = jQuery(this).closest('.h-video-wrap').find('.hero-video');

    jQuery(".play").hide();
    jQuery(".stop").show();
    if (jQuery(".stop").hasClass("active")) {
      mainVideo.currentTime = 0;
    }
    mainVideo.get(0).play();
  });
  jQuery(".stop").click(function () {
    let mainVideo = jQuery(this).closest('.h-video-wrap').find('.hero-video');

    jQuery(".play").show();
    jQuery(".stop").hide();
    jQuery(".stop").addClass("active");
    mainVideo.get(0).pause();
  });



}

function luCarousselValidForm(form) {
  var valid = true;

  if (form.find('#full_name').val() == '') {
    form.find('.full_name_error').show();
    valid = false;
  }
  else {
    form.find('.full_name_error').hide();
  }
  if (form.find('#contact_phone').val() == '') {
    form.find('.contact_phone_error').show();
    valid = false;
  }
  else {
    form.find('.contact_phone_error').hide();
  }
  if (form.find('#contact_email').val() == '') {
    if(form.find('#contact_email').data('required')){
    form.find('.contact_email_error').show();
    valid = false;
  }
}
  else {
    form.find('.contact_email_error').hide();
  }


  if (form.find('select.brands').val() == '' || form.find('select.brands').val() == '*בחר מותג' || form.find('select.brands').val() == '* בחר מותג') {
    form.find('.brands_error').show();
    valid = false;
  }
  else {
    form.find('.brands_error').hide();
  }
  if (form.find('select.contact_showroom').val() == '' || form.find('select.contact_showroom').val() == '*בחרו אולם תצוגה' || form.find('select.contact_showroom').val() == '* בחרו אולם תצוגה') {
    form.find('.contact_showroom_error').show();
    valid = false;
  }
  else {
    form.find('.contact_showroom_error').hide();
  }
  if (form.find('select.models').val() == '' || form.find('select.models').val() == '*בחר דגם' || form.find('select.models').val() == '* בחר דגם' || form.find('select.models').val() == null) {
    form.find('.models_error').show();
    valid = false;
  }
  else {
    form.find('.models_error').hide();
  }
  if (!form.find('input[name="privacy-question"]').is(':checked')) {
    //var width = jQuery('.tcu_agree_label .checkbox-holder').width() + jQuery('.tcu_agree_label .checkbox-text').width() + jQuery('.tcu_agree_label a').width();
    //form.find('.tcu_agree_error').width(width + 10).show();
    form.find('.privacy_question_error').show();
    valid = false;
  }
  else {
    form.find('.privacy_question_error').hide();
  }
  // if (!form.find('input[name="spam-question"]').is(':checked')) {
  //   //var width = jQuery('.tcu_agree_label .checkbox-holder').width() + jQuery('.tcu_agree_label .checkbox-text').width() + jQuery('.tcu_agree_label a').width();
  //   //form.find('.tcu_agree_error').width(width + 10).show();
  //   form.find('.spam_question_error').show();
  //   valid = false;
  // }
  // else {
  //   form.find('.spam_question_error').hide();
  // }

  return valid;
}


// WEBPACK FOOTER //
// assets/scripts/client/carrouselScript.js